module.exports = "<div class=\"popup\">\n    <div class=\"content\">\n        <p>{{sentence}}</p>\n    </div>\n    <div class=\"footer\">\n        <button (click)=\"accept()\">{{'common.yes' | translate}}</button>\n        <button (click)=\"refuse()\">{{'common.no' | translate}}</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popup/types/blacklistUnlock/popup-blacklist-unlock.component.html
// module id = 513
// module chunks = 0